import { useGetBranchTypesQuery } from "@me-team/host/main/branches/graphql/branches.hooks";
import { useParams } from "react-router-dom";

export const useBranchTypes = () => {
    const { branchId } = useParams();
    const { data, loading, error } = useGetBranchTypesQuery({
        variables: {
            branchId: Number(branchId),
            onlyChild: true,
            onlyMeMenu: true,
        },
    });

    return { data, loading, error };
};
